import { render } from "./MaintenanceMode.vue?vue&type=template&id=5f6a706c"
import script from "./MaintenanceMode.vue?vue&type=script&lang=js"
export * from "./MaintenanceMode.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__